var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"mb-5",staticStyle:{"width":"130px"},attrs:{"src":require('@/assets/images/pages/logo_piclink.png'),"alt":""}}),_c('b-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }